// Canonical stats — single source of truth for all metrics across the site.
// Each section uses a DIFFERENT subset so visitors never see the same grid twice.

export const STATS = {
  // Platform Scale (real numbers)
  activeUsers:          { value: "1,100+", label: "Monthly Active Users" },
  partnersLive:         { value: "4", label: "Partners Live" },
  languages:            { value: "50+", label: "Languages Supported" },

  // Operational Reliability
  uptimeSla:            { value: "99.9%", label: "Uptime SLA" },
  availability:         { value: "24/7", label: "Availability" },

  // Speed & Efficiency
  timeToLaunch:         { value: "2 weeks", label: "Avg. Time to Launch" },
  supportAvailability:  { value: "24/7", label: "Expert Support" },
} as const;

export type StatKey = keyof typeof STATS;

// Office locations — used on About and Contact pages
export const OFFICES = [
  {
    country: "Germany",
    label: "Headquarters",
    company: "IsarTech Company",
    street: "Holzerhof 18",
    postalCity: "85368 Wang",
    countryName: "Germany",
  },
  {
    country: "Austria",
    label: "European Office",
    company: "IsarTech Company",
    street: "Bruno-Marek-Allee 5",
    postalCity: "1020 Vienna",
    countryName: "Austria",
  },
] as const;

// Developer resource links — used in Footer and Contact sidebar
export const DEV_RESOURCES = [
  { name: "Documentation", href: "https://docs.isartech.io", showStatusDot: false },
  { name: "API Reference", href: "https://api.isartech.io", showStatusDot: false },
  { name: "System Status", href: "https://status.isartech.io", showStatusDot: true },
] as const;

// Trust & compliance badges — used in Hero and Testimonials
export const TRUST_BADGES = [
  { label: "SOC 2 Aligned" },
  { label: "GDPR Compliant" },
  { label: "Enterprise Ready" },
  { label: "99.9% Uptime SLA" },
] as const;

// Partner base data — extended by TrustedPartners and referenced by Testimonials
export const PARTNERS = [
  { name: "Danube", category: "Supermarket", logo: "D", color: "#E3FD6F" },
  { name: "BinDawood", category: "Retail Group", logo: "B", color: "#60A5FA" },
  { name: "Alfies", category: "Retail & B2B Orders", logo: "A", color: "#F472B6" },
  { name: "AYM Commerce", category: "E-Commerce", logo: "AYM", color: "#A78BFA" },
] as const;

// All external URLs — prevents scattered hardcoded links
export const EXTERNAL_LINKS = {
  docs: "https://docs.isartech.io",
  api: "https://api.isartech.io",
  status: "https://status.isartech.io",
  calendly: "https://calendly.com/isartech",
  authSignup: "https://auth.isartech.io/signup",
  authLogin: "https://auth.isartech.io/login",
  email: "info@isartech.io",
  playStore: "https://play.google.com/store/apps/details?id=com.app.danube",
  linkedin: "https://linkedin.com/company/isartech",
  twitter: "https://twitter.com/isartech",
  github: "https://github.com/isartech",
} as const;
